import { __awaiter, __generator } from "tslib";
import * as React from 'react';
import DropDownMenu from '../client/src/modules/chat/components/DropDownMenu/DropDownMenu';
import ModalComp from '../client/src/modules/chat/components/Modal/Modal';
import { domainAction } from '../client/src/modules/domain/domain-redux';
import { api } from '../client/src/modules/_core/utils/api-helpers';
import { getSessionThreadId } from '../client/src/modules/_core/utils/app-storage';
import StaffinoWidget from './sazka/components/StaffinoWidget';
import { headerOnCloseHandler } from './sazka/externals-fns/header-close-handler';
import ChevronRight from './sazka/assets/images/Chevron–right.svg';
var DEFAULT_MODAL_VARIANT = 'default';
var DropdownWithModal = function (props) {
    var cmp = props.cmp, openStaffino = props.openStaffino, content = props.content, handleCancel = props.handleCancel;
    var GDPRUrl = 'https://www.allwyn.cz/zpracovani-osobnich-udaju/ochrana-osobnich-udaju';
    var _a = React.useState(false), isModalOpen = _a[0], setIsModalOpen = _a[1];
    var _b = React.useState(), modalContent = _b[0], setModalContent = _b[1];
    var _c = React.useState(false), isSoundEnabled = _c[0], setIsSoundEnabled = _c[1];
    var _d = React.useState(DEFAULT_MODAL_VARIANT), modalVariant = _d[0], setModalVariant = _d[1];
    React.useEffect(function () {
        // external function is openining staffino
        if (openStaffino !== isModalOpen) {
            setIsModalOpen(openStaffino);
            setModalContent('staffino');
        }
    }, [openStaffino]);
    React.useEffect(function () {
        var useMsgSound = window.localStorage.getItem('useMsgSound');
        var isSoundEnabled = useMsgSound === 'true';
        setIsSoundEnabled(isSoundEnabled);
        domainAction.setUseMsgSound(isSoundEnabled);
    }, []);
    var handleSoundToggle = function () {
        setIsSoundEnabled(function (prev) {
            var next = !prev;
            window.localStorage.setItem('useMsgSound', String(next));
            cmp.props.dispatch(domainAction.setUseMsgSound(next));
            return next;
        });
    };
    var getModalContent = function () {
        var content;
        switch (modalContent) {
            case 'staffino':
                content = (React.createElement(StaffinoWidget, { handleSubmit: function (values) { return __awaiter(void 0, void 0, void 0, function () {
                        var threadId;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    threadId = getSessionThreadId();
                                    return [4 /*yield*/, api().sendStaffino(threadId, values)];
                                case 1:
                                    _a.sent();
                                    headerOnCloseHandler(cmp, function () { }, true);
                                    handleCancel();
                                    return [2 /*return*/];
                            }
                        });
                    }); }, handleCancel: function () {
                        headerOnCloseHandler(cmp, function () { }, true);
                        handleCancel();
                    }, onModalVariantChange: setModalVariant }));
                break;
            default:
                break;
        }
        return content;
    };
    React.useEffect(function () {
        if (modalContent !== 'staffino') {
            setModalVariant(DEFAULT_MODAL_VARIANT);
        }
    }, [modalContent]);
    var modalBody = getModalContent();
    var modalWrapClasses = ['sazka-modal', "sazka-modal--".concat(modalVariant)]
        .filter(Boolean)
        .join(' ');
    var modalDialogClasses = ['sazka-modal__dialog', "sazka-modal__dialog--".concat(modalVariant)]
        .filter(Boolean)
        .join(' ');
    var modalContentClasses = [
        'sazka-modal__content',
        "sazka-modal__content--".concat(modalVariant),
    ]
        .filter(Boolean)
        .join(' ');
    return (React.createElement(React.Fragment, null,
        React.createElement(DropDownMenu, { items: [
                {
                    id: 'sound',
                    toggle: false,
                    content: (React.createElement("div", { className: "sound-toggle" },
                        React.createElement("span", null, "".concat(isSoundEnabled ? 'Vypnout' : 'Zapnout', " zvuk chatu")),
                        React.createElement("label", { className: "switch" },
                            React.createElement("input", { type: "checkbox", checked: isSoundEnabled, onChange: function (event) {
                                    event.stopPropagation();
                                    handleSoundToggle();
                                } }),
                            React.createElement("span", { className: "slider" })))),
                },
                {
                    id: 'GDPR',
                    onClick: function () {
                        window.open(GDPRUrl, '_blank');
                    },
                    content: (React.createElement(React.Fragment, null,
                        React.createElement("a", { target: "_blank", href: GDPRUrl }, "GDPR"),
                        React.createElement("img", { src: ChevronRight, className: "chevron-icon" }))),
                },
            ], size: "sm" },
            React.createElement("span", { className: "menu-icon" })),
        React.createElement(ModalComp, { isModalOpen: isModalOpen, content: modalBody, handleClose: function () { return setIsModalOpen(handleCancel()); }, wrapClassName: modalWrapClasses, modalClassName: modalDialogClasses, contentClassName: modalContentClasses, hideFooter: true })));
};
export default DropdownWithModal;
